import React, { useState } from "react";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";

const USPosPriceToolTip = ({ usposid, usposmatch, setUSposmatch, setMktpricedata, url1, url2 }) => {
  //General
  const axiosPrivate = useAxiosPrivate();
  //States
  const [mktprice, setMktprice] = useState();
  // Classnames
  const showHideUSMktPriceTooltip = usposid === usposmatch ? "mktpriceupdatemenu" : "mktpriceupdatemenu display-none";

  // Functions
  const handleMktPriceChange = (e) => {
    const isdecimalnumber = RegExp("^[0-9.]+$");
    if (isdecimalnumber.test(e.target.value) || e.target.value === "") {
      setMktprice(e.target.value);
    }
  };
  const handleMktPriceSubmit = (e) => {
    e.preventDefault();
    axiosPrivate.post(`/api/positions/${url1}`, { mktprice, usposid }).then((response) => {
      if (response.data.success === true) {
        axiosPrivate.post(`/api/positions/${url2}`).then((response1) => {
          setMktpricedata(response1.data);
          setUSposmatch(0);
          setMktprice("");
        });
      }
    });
  };
  return (
    <div className={showHideUSMktPriceTooltip}>
      <form
        onSubmit={(e) => {
          handleMktPriceSubmit(e);
        }}
      >
        <input
          value={mktprice}
          onChange={(e) => {
            handleMktPriceChange(e);
          }}
          onDoubleClick={(e) => {
            e.target.select();
          }}
          required
        />
        <button type='submit'>Update</button>
      </form>
    </div>
  );
};

export default USPosPriceToolTip;
